// Taken from https://hopper-jira.atlassian.net/wiki/spaces/B2BTP/pages/5966725146/Air+Tracking+Spec

import type { FlightAppliedFilterEvent } from "./FlightAppliedFilterEvent";
import type { FlightChangedTripTypeEvent } from "./FlightChangedTripTypeEvent";
import { FlightCommonTrackingEventName } from "./FlightCommonTrackingEventName";
import type { FlightEntryEvent } from "./FlightEntryEvent";
import { FlightSearchTrackingEventName } from "./FlightSearchTrackingEventName";
import type { FlightSelectedEvent } from "./FlightSelectedEvent";
import { FlightShopTrackingEventName } from "./FlightShopTrackingEventName";
import type { FlightViewedAirSearchEvent } from "./FlightViewedAirSearchEvent";
import type { FlightViewedAmenityReviewEvent } from "./FlightViewedAmenityReviewEvent";
import type { FlightViewedForecastEvent } from "./FlightViewedForecastEvent";
import type { FlightViewedListEvent } from "./FlightViewedListEvent";
import type { FlightViewedShopLoadingEvent } from "./FlightViewedShopLoadingEvent";
import type { FlightViewedSliceEvent } from "./FlightViewedSliceEvent";
import type { FlightViewedTripSummaryEvent } from "./FlightViewedTripSummaryEvent";

export const FlightEventName = {
  ...FlightCommonTrackingEventName,
  ...FlightSearchTrackingEventName,
  ...FlightShopTrackingEventName,
};

export type FlightCoreEvent =
  | FlightEntryEvent
  | FlightViewedAirSearchEvent
  | FlightViewedShopLoadingEvent
  | FlightViewedListEvent
  | FlightViewedForecastEvent
  | FlightViewedSliceEvent
  | FlightViewedTripSummaryEvent
  | FlightViewedAmenityReviewEvent
  | FlightSelectedEvent
  | FlightChangedTripTypeEvent
  | FlightAppliedFilterEvent;

export {
  AppliedFilterType,
  type FlightAppliedFilterTrackingProperties,
} from "./FlightAppliedFilterEvent";

export { type FlightChangedTripTypeTrackingProperties } from "./FlightChangedTripTypeEvent";

export { type FlightEntryTrackingProperties } from "./FlightEntryEvent";

export { type FlightViewedForecastEventTrackingProps } from "./FlightViewedForecastEvent";

export { type FlightViewedListEvent } from "./FlightViewedListEvent";

export { type FlightViewedSliceEvent } from "./FlightViewedSliceEvent";

export { type FlightSelectedEvent } from "./FlightSelectedEvent";

export { type FlightViewedAirSearchEvent } from "./FlightViewedAirSearchEvent";

export { type FlightViewedTripSummaryEvent } from "./FlightViewedTripSummaryEvent";
